import React, { createContext, useState, useEffect } from 'react';
import useFetch from '../Components/Fetch/useFetch';

export const ThemeDataContext = createContext();

// Tier codes hidden from the portal, per programLabel. Hidden tiers must be
// the highest ones — maxPoints is capped where the first hidden tier begins.
const HIDDEN_TIER_CODES = {
  '1677A350-B638-4323-AA59-4F198482D63B': ['Internal'],
};

const withHiddenTiers = (customization) => {
  const hiddenCodes = HIDDEN_TIER_CODES[localStorage.getItem('programLabel')];
  if (!hiddenCodes || !customization?.tiers) return customization;

  const visible = customization.tiers.filter(
    (tier) => !hiddenCodes.includes(tier.code)
  );
  if (visible.length === customization.tiers.length || visible.length === 0) {
    return customization;
  }

  const hidden = customization.tiers.filter((tier) =>
    hiddenCodes.includes(tier.code)
  );

  return {
    ...customization,
    // The meter now ends where the lowest hidden tier begins.
    maxPoints: Math.min(...hidden.map((tier) => tier.value)),
    tiers: visible.map((tier, index) => ({
      ...tier,
      nextTier: index === visible.length - 1 ? 0 : tier.nextTier,
    })),
  };
};

// Every tier shown on the meter gets the same segment width, regardless of
// its points range. The meters map member points into these segments via
// getPointsPercentage (Container/meterMath.js).
const withEqualBarWidths = (customization) => {
  if (!customization?.tiers) return customization;

  const visibleCount = customization.tiers.filter(
    (tier) => tier.barPercentage > 0
  ).length;
  if (visibleCount === 0) return customization;

  return {
    ...customization,
    tiers: customization.tiers.map((tier) =>
      tier.barPercentage > 0
        ? { ...tier, barPercentage: 100 / visibleCount }
        : tier
    ),
  };
};

const buildTheme = (customization) =>
  withEqualBarWidths(withHiddenTiers(customization));

const ThemeContext = (props) => {
  const { data: customization } = useFetch('/api/init/getLoyaltyInfo');
  const [theme, setTheme] = useState(customization);

  useEffect(() => {
    const next = buildTheme(customization);
    if (JSON.stringify(theme) !== JSON.stringify(next)) {
      setTheme(next);
    }
  }, [customization, setTheme]);

  console.log('theme: ', theme);

  return (
    <ThemeDataContext.Provider value={theme}>
      {customization && props.children}
    </ThemeDataContext.Provider>
  );
};
export default ThemeContext;
